import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import {Property} from "../../property.model";

export class SubscriptionsSummary extends AbstractReport {

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

}

AccessorsMutatorsDecorator(
    'canceled',
    'expired',
    'future',
    'live',
    'non_renewing',
    'suspended',
    'trial',
    'trial_expired',
    'unpaid',
    'reactivated',
    'start',
    'end',
)(SubscriptionsSummary);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/admin-report/subscription-summary.model.js